export default __webpack_public_path__ + "static/drawn-arrow-c6527371af1392d738a048bc6128882f.svg";